// ============================================
// DESCRIPTIF SECTION - Extrait de PropertyForm.jsx
// Étape 1.6: Intégration avec ctx
// Behavior: INCHANGÉ
// ============================================
import React from 'react';

/**
 * Section Descriptif du formulaire de bien
 * @param {Object} ctx - Contexte partagé
 */
const DescriptifSection = ({ ctx }) => {
  const {
    formData,
    setFormData,
    activeDescriptionType,
    setActiveDescriptionType,
    activeDescriptionLang,
    setActiveDescriptionLang,
    DESCRIPTION_TYPES,
    LANGUAGES
  } = ctx;

  const handleDescriptionChange = (type, lang, content) => {
    setFormData(prev => ({
      ...prev,
      descriptif: {
        ...prev.descriptif,
        descriptions: {
          ...prev.descriptif?.descriptions,
          [type]: {
            ...prev.descriptif?.descriptions?.[type],
            [lang]: {
              content,
              optimized_by_ai: false
            }
          }
        }
      }
    }));
  };

  return (
    <div className="space-y-8">
      {/* Modern info header */}
      <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-indigo-500/5 via-violet-500/5 to-purple-500/10 border border-white/20 backdrop-blur-sm">
        <div className="absolute inset-0 bg-gradient-to-r from-indigo-600/10 to-violet-600/10"></div>
        <div className="relative p-6 flex items-center">
          <div className="w-16 h-16 bg-gradient-to-br from-indigo-500 to-violet-600 rounded-2xl flex items-center justify-center text-white mr-4 shadow-lg shadow-indigo-500/25">
            <i className="bi bi-file-text text-2xl"></i>
          </div>
          <div>
            <h2 className="text-2xl font-bold bg-gradient-to-r from-gray-800 to-indigo-600 bg-clip-text text-transparent">
              Descriptifs
            </h2>
            <p className="text-gray-600 font-medium">
              Rédigez les descriptions pour différents supports et langues
            </p>
          </div>
        </div>
      </div>

      {/* Type selector */}
      <div className="flex flex-wrap gap-2 mb-4">
        {(DESCRIPTION_TYPES || ['Fiche Technique', 'Web', 'Pub']).map((type) => (
          <button
            key={type}
            type="button"
            onClick={() => setActiveDescriptionType(type)}
            className={`px-4 py-2 rounded-lg font-medium transition-all ${
              activeDescriptionType === type
                ? 'bg-indigo-500 text-white'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }`}
          >
            {type}
          </button>
        ))}
      </div>

      {/* Language selector */}
      <div className="flex gap-2 mb-4">
        {(LANGUAGES || ['Français', 'Anglais']).map((lang) => (
          <button
            key={lang}
            type="button"
            onClick={() => setActiveDescriptionLang(lang)}
            className={`px-3 py-1.5 rounded-md text-sm font-medium transition-all ${
              activeDescriptionLang === lang
                ? 'bg-indigo-100 text-indigo-700 border border-indigo-300'
                : 'bg-gray-50 text-gray-600 hover:bg-gray-100'
            }`}
          >
            {lang}
          </button>
        ))}
      </div>

      {/* Description textarea */}
      <div className="bg-white rounded-2xl p-6 border border-gray-200">
        <textarea
          value={formData.descriptif?.descriptions?.[activeDescriptionType]?.[activeDescriptionLang]?.content || ''}
          onChange={(e) => handleDescriptionChange(activeDescriptionType, activeDescriptionLang, e.target.value)}
          rows={10}
          className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
          placeholder={`Rédigez la description ${activeDescriptionType} en ${activeDescriptionLang}...`}
        />
      </div>
    </div>
  );
};

export default DescriptifSection;
